
const deliveriesAndRates = (data) => ({
    ...window.helpers,
    loading: false,
    showResultsCount: 3,
    standard: JSON.parse(decodeURIComponent(data.standard)) || [],
    standardOrdered: [],
    premium: JSON.parse(decodeURIComponent(data.premium)) || [],
    premiumOrered: [],
    currentRate: 1,
    getNewCurrencyRate(currencyId) {
        window.api.get(`/m/accu/currencyRate?id_currency=${currencyId}`)
            .then((response) => {
                if (response.data.success === true) {
                    this.currentRate = response.data.exchange_rate
                } else {
                    window.dispatchEvent(new CustomEvent('create-toast', {
                        detail: {
                            title: 'oooops',
                            message: response.data.message,
                            type: 'error',
                        },
                    }))
                }
            }).catch(() => {
                window.dispatchEvent(new CustomEvent('create-toast', {
                    detail: {
                        title: 'oooops',
                        message: '',
                        type: 'error',
                    },
                }))
            })
    },
    init() {
        if (parseInt(window.Alpine.store('currency').id, 10) !== 3) {
            this.getNewCurrencyRate(parseInt(window.Alpine.store('currency').id, 10))
        } else {
            this.currentRate = 1
        }

        const standardx = []
        const premiumx = []
        Object.keys(this.standard).forEach(
            (property) => standardx.push(this.standard[property]),
        )
        Object.keys(this.premium).forEach(
            (property) => premiumx.push(this.premium[property]),
        )

        this.standardOrdered = standardx
        this.standardOrdered.sort((a, b) => {
            if (a.position < b.position) {
                return -1
            }
            if (a.position > b.position) {
                return 1
            }

            return 0
        })
        this.premiumOrdered = premiumx
        this.premiumOrdered.sort((a, b) => {
            if (a.position < b.position) {
                return -1
            }
            if (a.position > b.position) {
                return 1
            }

            return 0
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('deliveriesAndRates', deliveriesAndRates)
})
